/**
 * @description Extracts inline SVG from sprite symbol
 * @param {string} symbolId - The symbol ID (e.g., 'icon-marker')
 * @param {Object} options - Optional options object
 * @param {string} options.className - Optional CSS class to add to SVG
 * @param {boolean} options.returnElement - Optional flag to return SVG element instead of markup
 * @returns {string | SVGElement} SVG markup or element
 */
export const getInlineSvg = (symbolId, { className = '', returnElement = false } = {}) => {
  const symbol = document.getElementById(symbolId);
  if (!symbol) {
    console.warn(`SVG symbol "${symbolId}" not found`);
    return '';
  }

  const wrapperDiv = document.createElement('div');
  if (className) wrapperDiv.classList.add(className);
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  // Copy viewBox attribute
  const viewBox = symbol.getAttribute('viewBox');
  if (viewBox) svg.setAttribute('viewBox', viewBox);

  // Clone symbol content into SVG
  svg.innerHTML = symbol.innerHTML;

  wrapperDiv.appendChild(svg);

  return returnElement ? wrapperDiv : wrapperDiv.outerHTML;
};
